import { useState } from 'react';
import { Button, Modal, Stack, ActionIcon, Tooltip } from '@mantine/core';
import { IconFilter } from '@tabler/icons-react';
import { useDevice } from '@ayocore/platform/client/hooks/useDevice';

export interface AdaptiveFiltersProps {
  children: React.ReactNode;
  buttonLabel?: string;
  disabled?: boolean;
}

export function AdaptiveFilters({
  children,
  buttonLabel = 'Фильтры',
  disabled,
}: AdaptiveFiltersProps) {
  const { isMobile } = useDevice();
  const [opened, setOpened] = useState(false);

  if (!children) return null;
  if (!isMobile) return <>{children}</>;

  return (
    <>
      <Tooltip label={buttonLabel}>
        <ActionIcon
          size={30}
          variant='outline'
          onClick={() => setOpened(true)}
          disabled={disabled}
          aria-label={buttonLabel}
        >
          <IconFilter size={16} />
        </ActionIcon>
      </Tooltip>
      <Modal opened={opened} onClose={() => setOpened(false)} fullScreen title={buttonLabel}>
        <Stack gap='sm'>
          {children}
          <Button variant='outline' size='xs' onClick={() => setOpened(false)}>
            Закрыть
          </Button>
        </Stack>
      </Modal>
    </>
  );
}
